module.exports = __webpack_public_path__ + "img/wp-existing-habit-card13.afe212df.jpg";